// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Rajdhani:wght@600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tailwind CSS Directives */
*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
/* ! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com */
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}
::before,
::after {
  --tw-content: '';
}
/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/
html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}
/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}
/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}
/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  text-decoration: underline dotted;
}
/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}
/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}
/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}
/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}
/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}
/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sub {
  bottom: -0.25em;
}
sup {
  top: -0.5em;
}
/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}
/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}
/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}
/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}
/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}
/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}
/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}
/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}
/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}
/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}
/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}
/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}
fieldset {
  margin: 0;
  padding: 0;
}
legend {
  padding: 0;
}
ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}
/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}
/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}
/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/
input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}
/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}
/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}
/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}
/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}
/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.pointer-events-none {
  pointer-events: none;
}
.visible {
  visibility: visible;
}
.collapse {
  visibility: collapse;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.left-0 {
  left: 0px;
}
.left-3 {
  left: 0.75rem;
}
.right-0 {
  right: 0px;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.top-14 {
  top: 3.5rem;
}
.top-3 {
  top: 0.75rem;
}
.top-6 {
  top: 1.5rem;
}
.z-10 {
  z-index: 10;
}
.z-50 {
  z-index: 50;
}
.z-\\[60\\] {
  z-index: 60;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.order-3 {
  order: 3;
}
.order-4 {
  order: 4;
}
.order-5 {
  order: 5;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.-mx-4 {
  margin-left: -1rem;
  margin-right: -1rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.-mr-1 {
  margin-right: -0.25rem;
}
.-mt-1\\.5 {
  margin-top: -0.375rem;
}
.mb-0\\.5 {
  margin-bottom: 0.125rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-3\\.5 {
  margin-bottom: 0.875rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-7 {
  margin-bottom: 1.75rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-0\\.5 {
  margin-left: 0.125rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-1\\.5 {
  margin-left: 0.375rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-7 {
  margin-left: 1.75rem;
}
.ml-\\[21px\\] {
  margin-left: 21px;
}
.ml-auto {
  margin-left: auto;
}
.mr-1\\.5 {
  margin-right: 0.375rem;
}
.mr-auto {
  margin-right: auto;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-2\\.5 {
  margin-top: 0.625rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-3\\.5 {
  margin-top: 0.875rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-20 {
  height: 5rem;
}
.h-24 {
  height: 6rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-32 {
  height: 8rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-full {
  height: 100%;
}
.max-h-\\[85vh\\] {
  max-height: 85vh;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.min-h-\\[38px\\] {
  min-height: 38px;
}
.min-h-\\[40px\\] {
  min-height: 40px;
}
.min-h-\\[60px\\] {
  min-height: 60px;
}
.min-h-screen {
  min-height: 100vh;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-20 {
  width: 5rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-36 {
  width: 9rem;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-44 {
  width: 11rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-56 {
  width: 14rem;
}
.w-6 {
  width: 1.5rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[13px\\] {
  width: 13px;
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-\\[12rem\\] {
  min-width: 12rem;
}
.min-w-\\[18px\\] {
  min-width: 18px;
}
.min-w-\\[20px\\] {
  min-width: 20px;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-4xl {
  max-width: 56rem;
}
.max-w-5xl {
  max-width: 64rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-\\[140px\\] {
  max-width: 140px;
}
.max-w-\\[45\\%\\] {
  max-width: 45%;
}
.max-w-\\[75vw\\] {
  max-width: 75vw;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-sm {
  max-width: 24rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse {
  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-default {
  cursor: default;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.resize-none {
  resize: none;
}
.list-disc {
  list-style-type: disc;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-\\[1\\.1fr_1\\.5fr_1\\.7fr_0\\.9fr_auto\\] {
  grid-template-columns: 1.1fr 1.5fr 1.7fr 0.9fr auto;
}
.grid-cols-\\[1\\.3fr_1\\.5fr_1\\.2fr_1fr_1fr\\] {
  grid-template-columns: 1.3fr 1.5fr 1.2fr 1fr 1fr;
}
.grid-cols-\\[2\\.75rem_minmax\\(0\\2c 1fr\\)\\] {
  grid-template-columns: 2.75rem minmax(0,1fr);
}
.grid-cols-\\[6\\.5rem_minmax\\(0\\2c 1fr\\)\\] {
  grid-template-columns: 6.5rem minmax(0,1fr);
}
.grid-cols-\\[8\\.5rem_minmax\\(0\\2c 1fr\\)\\] {
  grid-template-columns: 8.5rem minmax(0,1fr);
}
.grid-cols-\\[9rem_minmax\\(0\\2c 1fr\\)\\] {
  grid-template-columns: 9rem minmax(0,1fr);
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-0 {
  gap: 0px;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-3\\.5 {
  gap: 0.875rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-x-3 {
  column-gap: 0.75rem;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.gap-y-1\\.5 {
  row-gap: 0.375rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-3\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.875rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.875rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-\\[\\#546E7A\\]\\/10 > :not([hidden]) ~ :not([hidden]) {
  border-color: rgb(84 110 122 / 0.1);
}
.divide-\\[\\#546E7A\\]\\/20 > :not([hidden]) ~ :not([hidden]) {
  border-color: rgb(84 110 122 / 0.2);
}
.self-start {
  align-self: flex-start;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-y-auto {
  overflow-y: auto;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-t {
  border-top-width: 1px;
}
.border-dashed {
  border-style: dashed;
}
.border-\\[\\#00C853\\]\\/30 {
  border-color: rgb(0 200 83 / 0.3);
}
.border-\\[\\#00D4FF\\] {
  --tw-border-opacity: 1;
  border-color: rgb(0 212 255 / var(--tw-border-opacity, 1));
}
.border-\\[\\#00D4FF\\]\\/25 {
  border-color: rgb(0 212 255 / 0.25);
}
.border-\\[\\#00D4FF\\]\\/30 {
  border-color: rgb(0 212 255 / 0.3);
}
.border-\\[\\#00D4FF\\]\\/35 {
  border-color: rgb(0 212 255 / 0.35);
}
.border-\\[\\#00D4FF\\]\\/40 {
  border-color: rgb(0 212 255 / 0.4);
}
.border-\\[\\#00D4FF\\]\\/50 {
  border-color: rgb(0 212 255 / 0.5);
}
.border-\\[\\#00D4FF\\]\\/60 {
  border-color: rgb(0 212 255 / 0.6);
}
.border-\\[\\#00E676\\] {
  --tw-border-opacity: 1;
  border-color: rgb(0 230 118 / var(--tw-border-opacity, 1));
}
.border-\\[\\#00E676\\]\\/20 {
  border-color: rgb(0 230 118 / 0.2);
}
.border-\\[\\#00E676\\]\\/30 {
  border-color: rgb(0 230 118 / 0.3);
}
.border-\\[\\#00E676\\]\\/35 {
  border-color: rgb(0 230 118 / 0.35);
}
.border-\\[\\#00E676\\]\\/40 {
  border-color: rgb(0 230 118 / 0.4);
}
.border-\\[\\#00E676\\]\\/50 {
  border-color: rgb(0 230 118 / 0.5);
}
.border-\\[\\#00E676\\]\\/60 {
  border-color: rgb(0 230 118 / 0.6);
}
.border-\\[\\#243B55\\] {
  --tw-border-opacity: 1;
  border-color: rgb(36 59 85 / var(--tw-border-opacity, 1));
}
.border-\\[\\#243B55\\]\\/50 {
  border-color: rgb(36 59 85 / 0.5);
}
.border-\\[\\#546E7A\\]\\/15 {
  border-color: rgb(84 110 122 / 0.15);
}
.border-\\[\\#546E7A\\]\\/20 {
  border-color: rgb(84 110 122 / 0.2);
}
.border-\\[\\#546E7A\\]\\/25 {
  border-color: rgb(84 110 122 / 0.25);
}
.border-\\[\\#546E7A\\]\\/30 {
  border-color: rgb(84 110 122 / 0.3);
}
.border-\\[\\#546E7A\\]\\/35 {
  border-color: rgb(84 110 122 / 0.35);
}
.border-\\[\\#546E7A\\]\\/40 {
  border-color: rgb(84 110 122 / 0.4);
}
.border-\\[\\#546E7A\\]\\/50 {
  border-color: rgb(84 110 122 / 0.5);
}
.border-\\[\\#7E57C2\\]\\/40 {
  border-color: rgb(126 87 194 / 0.4);
}
.border-\\[\\#B39DDB\\]\\/40 {
  border-color: rgb(179 157 219 / 0.4);
}
.border-\\[\\#EF5350\\]\\/30 {
  border-color: rgb(239 83 80 / 0.3);
}
.border-\\[\\#EF5350\\]\\/35 {
  border-color: rgb(239 83 80 / 0.35);
}
.border-\\[\\#EF5350\\]\\/40 {
  border-color: rgb(239 83 80 / 0.4);
}
.border-\\[\\#EF5350\\]\\/50 {
  border-color: rgb(239 83 80 / 0.5);
}
.border-\\[\\#FF6B00\\]\\/40 {
  border-color: rgb(255 107 0 / 0.4);
}
.border-\\[\\#FFB300\\]\\/30 {
  border-color: rgb(255 179 0 / 0.3);
}
.border-\\[\\#FFB300\\]\\/35 {
  border-color: rgb(255 179 0 / 0.35);
}
.border-\\[\\#FFB300\\]\\/40 {
  border-color: rgb(255 179 0 / 0.4);
}
.border-\\[\\#FFB300\\]\\/50 {
  border-color: rgb(255 179 0 / 0.5);
}
.border-\\[\\#FFD600\\]\\/30 {
  border-color: rgb(255 214 0 / 0.3);
}
.border-blue-600\\/30 {
  border-color: rgb(37 99 235 / 0.3);
}
.border-blue-700\\/30 {
  border-color: rgb(29 78 216 / 0.3);
}
.border-gray-600 {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}
.border-gray-600\\/30 {
  border-color: rgb(75 85 99 / 0.3);
}
.border-gray-700 {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}
.border-green-600\\/30 {
  border-color: rgb(22 163 74 / 0.3);
}
.border-green-700\\/50 {
  border-color: rgb(21 128 61 / 0.5);
}
.border-orange-600\\/30 {
  border-color: rgb(234 88 12 / 0.3);
}
.border-purple-600\\/30 {
  border-color: rgb(147 51 234 / 0.3);
}
.border-red-600\\/30 {
  border-color: rgb(220 38 38 / 0.3);
}
.border-red-700 {
  --tw-border-opacity: 1;
  border-color: rgb(185 28 28 / var(--tw-border-opacity, 1));
}
.border-red-700\\/50 {
  border-color: rgb(185 28 28 / 0.5);
}
.border-transparent {
  border-color: transparent;
}
.border-yellow-600 {
  --tw-border-opacity: 1;
  border-color: rgb(202 138 4 / var(--tw-border-opacity, 1));
}
.border-yellow-600\\/20 {
  border-color: rgb(202 138 4 / 0.2);
}
.border-yellow-600\\/30 {
  border-color: rgb(202 138 4 / 0.3);
}
.border-yellow-700\\/30 {
  border-color: rgb(161 98 7 / 0.3);
}
.bg-\\[\\#00C853\\]\\/10 {
  background-color: rgb(0 200 83 / 0.1);
}
.bg-\\[\\#00D4FF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 212 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#00D4FF\\]\\/10 {
  background-color: rgb(0 212 255 / 0.1);
}
.bg-\\[\\#00D4FF\\]\\/15 {
  background-color: rgb(0 212 255 / 0.15);
}
.bg-\\[\\#00D4FF\\]\\/20 {
  background-color: rgb(0 212 255 / 0.2);
}
.bg-\\[\\#00D4FF\\]\\/\\[0\\.06\\] {
  background-color: rgb(0 212 255 / 0.06);
}
.bg-\\[\\#00E676\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(0 230 118 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#00E676\\]\\/10 {
  background-color: rgb(0 230 118 / 0.1);
}
.bg-\\[\\#00E676\\]\\/15 {
  background-color: rgb(0 230 118 / 0.15);
}
.bg-\\[\\#00E676\\]\\/5 {
  background-color: rgb(0 230 118 / 0.05);
}
.bg-\\[\\#00E676\\]\\/\\[0\\.05\\] {
  background-color: rgb(0 230 118 / 0.05);
}
.bg-\\[\\#00E676\\]\\/\\[0\\.06\\] {
  background-color: rgb(0 230 118 / 0.06);
}
.bg-\\[\\#00E676\\]\\/\\[0\\.07\\] {
  background-color: rgb(0 230 118 / 0.07);
}
.bg-\\[\\#0A0E27\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(10 14 39 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0A0E27\\]\\/50 {
  background-color: rgb(10 14 39 / 0.5);
}
.bg-\\[\\#0A1628\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(10 22 40 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0D1229\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(13 18 41 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#12233D\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(18 35 61 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1A2744\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(26 39 68 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#243B55\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(36 59 85 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#243B55\\]\\/40 {
  background-color: rgb(36 59 85 / 0.4);
}
.bg-\\[\\#243B55\\]\\/50 {
  background-color: rgb(36 59 85 / 0.5);
}
.bg-\\[\\#243B55\\]\\/60 {
  background-color: rgb(36 59 85 / 0.6);
}
.bg-\\[\\#546E7A\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(84 110 122 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#546E7A\\]\\/15 {
  background-color: rgb(84 110 122 / 0.15);
}
.bg-\\[\\#EF5350\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 83 80 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EF5350\\]\\/10 {
  background-color: rgb(239 83 80 / 0.1);
}
.bg-\\[\\#EF5350\\]\\/\\[0\\.07\\] {
  background-color: rgb(239 83 80 / 0.07);
}
.bg-\\[\\#FFB300\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 179 0 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#FFB300\\]\\/10 {
  background-color: rgb(255 179 0 / 0.1);
}
.bg-\\[\\#FFB300\\]\\/\\[0\\.06\\] {
  background-color: rgb(255 179 0 / 0.06);
}
.bg-\\[\\#FFB300\\]\\/\\[0\\.07\\] {
  background-color: rgb(255 179 0 / 0.07);
}
.bg-\\[\\#FFD600\\]\\/10 {
  background-color: rgb(255 214 0 / 0.1);
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/60 {
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/70 {
  background-color: rgb(0 0 0 / 0.7);
}
.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-blue-600\\/20 {
  background-color: rgb(37 99 235 / 0.2);
}
.bg-blue-900\\/30 {
  background-color: rgb(30 58 138 / 0.3);
}
.bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.bg-gray-600\\/20 {
  background-color: rgb(75 85 99 / 0.2);
}
.bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-green-600\\/20 {
  background-color: rgb(22 163 74 / 0.2);
}
.bg-green-900\\/30 {
  background-color: rgb(20 83 45 / 0.3);
}
.bg-orange-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}
.bg-orange-600\\/20 {
  background-color: rgb(234 88 12 / 0.2);
}
.bg-purple-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
.bg-purple-600\\/20 {
  background-color: rgb(147 51 234 / 0.2);
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-red-600\\/20 {
  background-color: rgb(220 38 38 / 0.2);
}
.bg-red-900\\/20 {
  background-color: rgb(127 29 29 / 0.2);
}
.bg-red-900\\/30 {
  background-color: rgb(127 29 29 / 0.3);
}
.bg-red-900\\/50 {
  background-color: rgb(127 29 29 / 0.5);
}
.bg-transparent {
  background-color: transparent;
}
.bg-yellow-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / var(--tw-bg-opacity, 1));
}
.bg-yellow-600\\/10 {
  background-color: rgb(202 138 4 / 0.1);
}
.bg-yellow-600\\/20 {
  background-color: rgb(202 138 4 / 0.2);
}
.bg-yellow-900\\/15 {
  background-color: rgb(113 63 18 / 0.15);
}
.bg-yellow-900\\/50 {
  background-color: rgb(113 63 18 / 0.5);
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-\\[\\#00D4FF\\] {
  --tw-gradient-from: #00D4FF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 212 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-\\[\\#00E676\\] {
  --tw-gradient-to: #00E676 var(--tw-gradient-to-position);
}
.object-cover {
  object-fit: cover;
}
.p-0 {
  padding: 0px;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-3\\.5 {
  padding: 0.875rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-12 {
  padding-bottom: 3rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-9 {
  padding-left: 2.25rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-12 {
  padding-top: 3rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-8 {
  padding-top: 2rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.align-middle {
  vertical-align: middle;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-rajdhani {
  font-family: Rajdhani, sans-serif;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[9px\\] {
  font-size: 9px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-none {
  line-height: 1;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[0\\.12em\\] {
  letter-spacing: 0.12em;
}
.tracking-\\[0\\.1em\\] {
  letter-spacing: 0.1em;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.text-\\[\\#00C853\\] {
  --tw-text-opacity: 1;
  color: rgb(0 200 83 / var(--tw-text-opacity, 1));
}
.text-\\[\\#00D4FF\\] {
  --tw-text-opacity: 1;
  color: rgb(0 212 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#00D4FF\\]\\/50 {
  color: rgb(0 212 255 / 0.5);
}
.text-\\[\\#00E676\\] {
  --tw-text-opacity: 1;
  color: rgb(0 230 118 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0A0E27\\] {
  --tw-text-opacity: 1;
  color: rgb(10 14 39 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2A4060\\] {
  --tw-text-opacity: 1;
  color: rgb(42 64 96 / var(--tw-text-opacity, 1));
}
.text-\\[\\#37474F\\] {
  --tw-text-opacity: 1;
  color: rgb(55 71 79 / var(--tw-text-opacity, 1));
}
.text-\\[\\#546E7A\\] {
  --tw-text-opacity: 1;
  color: rgb(84 110 122 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7E57C2\\] {
  --tw-text-opacity: 1;
  color: rgb(126 87 194 / var(--tw-text-opacity, 1));
}
.text-\\[\\#B0BEC5\\] {
  --tw-text-opacity: 1;
  color: rgb(176 190 197 / var(--tw-text-opacity, 1));
}
.text-\\[\\#B39DDB\\] {
  --tw-text-opacity: 1;
  color: rgb(179 157 219 / var(--tw-text-opacity, 1));
}
.text-\\[\\#C8D8E8\\] {
  --tw-text-opacity: 1;
  color: rgb(200 216 232 / var(--tw-text-opacity, 1));
}
.text-\\[\\#EF5350\\] {
  --tw-text-opacity: 1;
  color: rgb(239 83 80 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FF8A3D\\] {
  --tw-text-opacity: 1;
  color: rgb(255 138 61 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FFB300\\] {
  --tw-text-opacity: 1;
  color: rgb(255 179 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FFD600\\] {
  --tw-text-opacity: 1;
  color: rgb(255 214 0 / var(--tw-text-opacity, 1));
}
.text-blue-100 {
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / var(--tw-text-opacity, 1));
}
.text-blue-300 {
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}
.text-blue-400 {
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.text-gray-100 {
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}
.text-gray-200 {
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-green-100 {
  --tw-text-opacity: 1;
  color: rgb(220 252 231 / var(--tw-text-opacity, 1));
}
.text-green-300 {
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity, 1));
}
.text-green-400 {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.text-orange-100 {
  --tw-text-opacity: 1;
  color: rgb(255 237 213 / var(--tw-text-opacity, 1));
}
.text-orange-300 {
  --tw-text-opacity: 1;
  color: rgb(253 186 116 / var(--tw-text-opacity, 1));
}
.text-purple-100 {
  --tw-text-opacity: 1;
  color: rgb(243 232 255 / var(--tw-text-opacity, 1));
}
.text-purple-300 {
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity, 1));
}
.text-red-300 {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.text-red-400 {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-yellow-100 {
  --tw-text-opacity: 1;
  color: rgb(254 249 195 / var(--tw-text-opacity, 1));
}
.text-yellow-200 {
  --tw-text-opacity: 1;
  color: rgb(254 240 138 / var(--tw-text-opacity, 1));
}
.text-yellow-300 {
  --tw-text-opacity: 1;
  color: rgb(253 224 71 / var(--tw-text-opacity, 1));
}
.text-yellow-300\\/80 {
  color: rgb(253 224 71 / 0.8);
}
.text-yellow-400 {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.line-through {
  text-decoration-line: line-through;
}
.no-underline {
  text-decoration-line: none;
}
.decoration-\\[\\#EF5350\\]\\/70 {
  text-decoration-color: rgb(239 83 80 / 0.7);
}
.placeholder-\\[\\#546E7A\\]::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(84 110 122 / var(--tw-placeholder-opacity, 1));
}
.placeholder-gray-400::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity, 1));
}
.placeholder-gray-500::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(107 114 128 / var(--tw-placeholder-opacity, 1));
}
.accent-\\[\\#00D4FF\\] {
  accent-color: #00D4FF;
}
.opacity-0 {
  opacity: 0;
}
.opacity-20 {
  opacity: 0.2;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline {
  outline-style: solid;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.delay-100 {
  transition-delay: 100ms;
}
.delay-200 {
  transition-delay: 200ms;
}
.delay-300 {
  transition-delay: 300ms;
}
.delay-700 {
  transition-delay: 700ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.\\[overflow-wrap\\:anywhere\\] {
  overflow-wrap: anywhere;
}

/* AiDA Advisory - Global Styles */

/* CSS Reset & Base */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  /* Backgrounds - Deep navy/space theme from logo */
  --bg-primary: #0A0E27;
  --bg-card: #1A2744;
  --bg-elevated: #243B55;
  
  /* Accent Colors - Bright cyan from logo */
  --accent-cyan: #00D4FF;
  --accent-light: #4FC3F7;
  --accent-glow: rgba(0, 212, 255, 0.3);
  
  /* Score Colors */
  --score-green: #00E676;
  --score-elite: #00E676;
  --score-strong: #00C853;
  --score-good: #FFD600;
  --score-marginal: #FFB300;
  --score-poor: #EF5350;
  
  /* Dimension Colors */
  --scheme-fit: #00D4FF;
  --skill-fit: #FFB300;
  --physical-fit: #00E676;
  --mental-fit: #7E57C2;
  --context-fit: #546E7A;
  
  /* Status Colors */
  --warn-amber: #FFB300;
  --risk-red: #EF5350;
  
  /* Text Colors */
  --text-primary: #FFFFFF;
  --text-muted: #B0BEC5;
  --text-dim: #546E7A;
  
  /* Borders */
  --border: #546E7A;
  --border-light: rgba(84, 110, 122, 0.3);
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
}

/* Number font for scores */
.font-rajdhani {
  font-family: 'Rajdhani', sans-serif;
}

/* Animations */
@keyframes pulse-glow {
  0%, 100% {
    box-shadow: 0 0 20px rgba(0, 230, 118, 0.4);
  }
  50% {
    box-shadow: 0 0 40px rgba(0, 230, 118, 0.6);
  }
}

@keyframes cyan-glow {
  0%, 100% {
    box-shadow: 0 0 20px rgba(0, 212, 255, 0.4);
  }
  50% {
    box-shadow: 0 0 40px rgba(0, 212, 255, 0.6);
  }
}

.pulse-glow {
  animation: pulse-glow 2s ease-in-out;
}

.cyan-glow {
  animation: cyan-glow 2s ease-in-out infinite;
}

@keyframes slideInLeft {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.slide-in-left {
  animation: slideInLeft 0.6s ease-out forwards;
  opacity: 0;
}

.delay-100 { animation-delay: 0.1s; }
.delay-200 { animation-delay: 0.2s; }
.delay-300 { animation-delay: 0.3s; }
.delay-400 { animation-delay: 0.4s; }
.delay-500 { animation-delay: 0.5s; }
.delay-600 { animation-delay: 0.6s; }

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-in {
  animation: fadeIn 0.5s ease-out forwards;
}

/* Panel base styles */
.panel-card {
  background-color: var(--bg-card);
  border: 1px solid var(--border-light);
  border-radius: 12px;
  padding: 1.25rem;
  transition: all 0.3s ease;
}

.panel-card:hover {
  border-color: var(--accent-light);
  box-shadow: inset 0 1px 0 rgba(79, 195, 247, 0.1);
}

/* Tab styles */
.tab-active {
  border-bottom: 2px solid var(--accent-cyan);
  color: var(--text-primary);
  font-weight: 600;
  padding-bottom: 0.5rem;
}

.tab-inactive {
  color: var(--text-muted);
  padding-bottom: 0.5rem;
  cursor: pointer;
  transition: color 0.2s;
}

.tab-inactive:hover {
  color: var(--text-primary);
}

/* Button styles */
.btn-primary {
  background-color: var(--accent-cyan);
  color: var(--bg-primary);
  font-weight: 600;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.3);
  font-size: 14px;
}

.btn-primary:hover {
  background-color: var(--accent-light);
  box-shadow: 0 0 30px rgba(0, 212, 255, 0.5);
  transform: translateY(-2px);
}

.btn-secondary {
  background-color: transparent;
  color: var(--text-primary);
  font-weight: 600;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  border: 2px solid var(--border);
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
}

.btn-secondary:hover {
  border-color: var(--accent-light);
  color: var(--accent-light);
}

/* Link styles */
a {
  color: var(--accent-cyan);
  text-decoration: none;
  transition: color 0.2s;
}

a:hover {
  color: var(--accent-light);
}

/* Utility classes */
.text-cyan {
  color: var(--accent-cyan);
}

.text-green {
  color: var(--score-green);
}

.text-amber {
  color: var(--warn-amber);
}

.text-muted {
  color: var(--text-muted);
}

.bg-card {
  background-color: var(--bg-card);
}

.border-cyan {
  border-color: var(--accent-cyan);
}

/* ==========================================================================
   MOBILE / NATIVE-APP LAYER
   Goal: on a phone this should read as an installed app, not a shrunken
   desktop site. Desktop (>= 768px) behavior is intentionally left unchanged.
   ========================================================================== */

:root {
  /* Safe areas (notch / home indicator). Fall back to 0 off-device. */
  --safe-top: env(safe-area-inset-top, 0px);
  --safe-bottom: env(safe-area-inset-bottom, 0px);
  --safe-left: env(safe-area-inset-left, 0px);
  --safe-right: env(safe-area-inset-right, 0px);

  /* Chrome heights, used to offset fixed bars */
  --appbar-h: 56px;
  --tabbar-h: 56px;
}

html {
  /* Stop iOS inflating text when the device rotates */
  text-size-adjust: 100%;
}

body {
  /* Kill the gray flash box on tap - the single biggest "this is a webpage" tell */
  -webkit-tap-highlight-color: transparent;
  /* No rubber-band chaining to the document / no pull-to-refresh bounce */
  overscroll-behavior-y: none;
}

/* Native-feeling momentum scrolling inside scroll regions */
.scroll-y {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

/* App chrome should not be text-selectable the way a document is */
.app-chrome {
  -webkit-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
}

@media (max-width: 767px) {
  /* iOS zooms the viewport when a focused input is under 16px. This is the
     other classic "not an app" tell, so force 16px on every text control. */
  input,
  select,
  textarea {
    font-size: 16px !important;
  }

  /* Touch targets: 44px is the Apple HIG minimum, 48dp the Material one. */
  button,
  [role="button"],
  a.tap,
  select {
    min-height: 44px;
  }

  /* Tighter gutters than the desktop px-6 */
  .panel-card {
    padding: 1rem;
    border-radius: 14px;
  }

  /* Hover styling is meaningless on touch and leaves stuck states */
  .panel-card:hover {
    border-color: var(--border-light);
    box-shadow: none;
  }

  .btn-primary,
  .btn-secondary {
    padding: 0.875rem 1.25rem;
    font-size: 15px;
  }
}

/* On any touch device, replace hover affordances with press feedback.
   The desktop translateY(-2px) hover reads as a glitch under a finger. */
@media (hover: none) {
  .btn-primary:hover,
  .btn-secondary:hover {
    transform: none;
    box-shadow: 0 0 20px rgba(0, 212, 255, 0.3);
  }

  .btn-primary:active,
  .btn-secondary:active,
  .tap:active {
    transform: scale(0.97);
    opacity: 0.85;
  }

  .panel-card:hover {
    border-color: var(--border-light);
    box-shadow: none;
  }
}

/* --------------------------------------------------------------------------
   App shell: fixed top app bar + fixed bottom tab bar (mobile only)
   -------------------------------------------------------------------------- */

.app-bar {
  position: sticky;
  top: 0;
  z-index: 40;
  padding-top: var(--safe-top);
  background-color: rgba(26, 39, 68, 0.92);
  backdrop-filter: saturate(180%) blur(12px);
  -webkit-backdrop-filter: saturate(180%) blur(12px);
  border-bottom: 1px solid var(--border-light);
}

.tab-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 50;
  display: flex;
  align-items: stretch;
  padding-bottom: var(--safe-bottom);
  padding-left: var(--safe-left);
  padding-right: var(--safe-right);
  background-color: rgba(26, 39, 68, 0.94);
  backdrop-filter: saturate(180%) blur(16px);
  -webkit-backdrop-filter: saturate(180%) blur(16px);
  border-top: 1px solid var(--border-light);
}

.tab-bar-item {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  height: var(--tabbar-h);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: var(--text-dim);
  background: none;
  border: none;
  cursor: pointer;
  transition: color 0.15s ease;
  min-width: 0;
}

.tab-bar-item.is-active {
  color: var(--accent-cyan);
}

.tab-bar-item:active {
  opacity: 0.6;
}

.tab-bar-item span {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Content must clear the fixed tab bar */
@media (max-width: 767px) {
  .has-tab-bar {
    padding-bottom: calc(var(--tabbar-h) + var(--safe-bottom) + 12px);
  }
}

/* --------------------------------------------------------------------------
   Sheets: modals become bottom sheets on mobile, stay dialogs on desktop
   -------------------------------------------------------------------------- */

@keyframes sheet-up {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes overlay-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.sheet-overlay {
  animation: overlay-in 0.2s ease-out;
}

@media (max-width: 767px) {
  /* Pin the overlay to the viewport and let the sheet own the bottom edge */
  .sheet-overlay {
    align-items: flex-end !important;
    padding: 0 !important;
  }

  .sheet {
    width: 100% !important;
    max-width: 100% !important;
    max-height: 92vh !important;
    border-radius: 18px 18px 0 0 !important;
    animation: sheet-up 0.28s cubic-bezier(0.32, 0.72, 0, 1);
    padding-bottom: calc(var(--safe-bottom) + 8px);
  }

  /* The little grab handle that signals "drag/dismiss" on native sheets */
  .sheet::before {
    content: "";
    display: block;
    width: 36px;
    height: 4px;
    border-radius: 999px;
    background: var(--border);
    margin: 10px auto 4px;
    flex-shrink: 0;
  }
}

/* --------------------------------------------------------------------------
   Table -> card list. Wrap a <table> in .table-wrap and it scrolls on
   desktop; screens that provide a .card-list fallback hide the table instead.
   -------------------------------------------------------------------------- */

.table-wrap {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.mobile-only {
  display: none;
}

@media (max-width: 767px) {
  .mobile-only {
    display: block;
  }

  .desktop-only {
    display: none !important;
  }
}

/* For tables too wide for a tablet: the table from 1024px up, the card list below. */
.narrow-only {
  display: none;
}

@media (max-width: 1023px) {
  .narrow-only {
    display: block;
  }

  .wide-only {
    display: none !important;
  }
}

/* A tappable row/card in a mobile list */
.list-card {
  background-color: var(--bg-card);
  border: 1px solid var(--border-light);
  border-radius: 14px;
  padding: 0.875rem 1rem;
  display: block;
  width: 100%;
  text-align: left;
  transition: background-color 0.15s ease;
}

.list-card:active {
  background-color: var(--bg-elevated);
}

/* A row of chips/filters. It wraps onto more lines; it never scrolls sideways. */
.chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding-bottom: 2px;
}

.chip-row::-webkit-scrollbar {
  display: none;
}

.chip {
  flex: 0 0 auto;
  padding: 0.5rem 0.875rem;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  border: 1px solid var(--border-light);
  background-color: var(--bg-card);
  color: var(--text-muted);
  cursor: pointer;
}

.chip.is-active {
  background-color: var(--accent-cyan);
  border-color: var(--accent-cyan);
  color: var(--bg-primary);
}

/* Respect reduced-motion preferences */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}

/* --------------------------------------------------------------------------
   Public profile section tabs

   Pinned under the app bar so they stay reachable while reading, with the
   active section tracked as you scroll. Six labels cannot fit across a phone,
   so the strip scrolls horizontally -- the same pattern as Material's
   scrollable tabs -- and a fade on the trailing edge signals there is more.
   -------------------------------------------------------------------------- */

.section-nav {
  position: sticky;
  top: calc(var(--safe-top) + 56px);
  z-index: 30;
  margin: 0 -1rem 1.25rem;
  padding: 0.5rem 1rem;
  background-color: rgba(10, 14, 39, 0.94);
  backdrop-filter: saturate(180%) blur(12px);
  -webkit-backdrop-filter: saturate(180%) blur(12px);
  border-bottom: 1px solid var(--border-light);
}

@media (min-width: 768px) {
  .section-nav {
    top: 0;
    margin-left: 0;
    margin-right: 0;
    padding-left: 0;
    padding-right: 0;
  }
}

/* Trailing fade: the affordance that says "this strip keeps going" */
.section-nav::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 28px;
  pointer-events: none;
  background: linear-gradient(to right, rgba(10, 14, 39, 0), rgba(10, 14, 39, 0.94));
}

.section-nav .chip-row {
  gap: 0.4rem;
  scroll-behavior: smooth;
}

.section-nav .chip {
  padding: 0.45rem 0.7rem;
  font-size: 12px;
  letter-spacing: -0.01em;
  text-decoration: none;
  scroll-margin-inline: 1rem;
}

/* On a narrow phone, let the strip use the full width before it scrolls */
@media (max-width: 400px) {
  .section-nav .chip {
    padding: 0.45rem 0.6rem;
    font-size: 11.5px;
  }
  .section-nav .chip-row {
    gap: 0.3rem;
  }
}

.section-nav .chip.is-active {
  background-color: var(--accent-cyan);
  border-color: var(--accent-cyan);
  color: var(--bg-primary);
}

/* Anchor targets must clear both the app bar and the pinned tab strip */
.section-anchor {
  scroll-margin-top: calc(var(--safe-top) + 56px + 52px + 8px);
}

@media (min-width: 768px) {
  .section-anchor {
    scroll-margin-top: 72px;
  }
}

.first\\:pt-0:first-child {
  padding-top: 0px;
}

.last\\:mb-0:last-child {
  margin-bottom: 0px;
}

.last\\:border-0:last-child {
  border-width: 0px;
}

.last\\:pb-0:last-child {
  padding-bottom: 0px;
}

.hover\\:border-\\[\\#00D4FF\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(0 212 255 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[\\#00D4FF\\]\\/50:hover {
  border-color: rgb(0 212 255 / 0.5);
}

.hover\\:border-\\[\\#EF5350\\]\\/60:hover {
  border-color: rgb(239 83 80 / 0.6);
}

.hover\\:bg-\\[\\#00D4FF\\]\\/20:hover {
  background-color: rgb(0 212 255 / 0.2);
}

.hover\\:bg-\\[\\#00D4FF\\]\\/90:hover {
  background-color: rgb(0 212 255 / 0.9);
}

.hover\\:bg-\\[\\#00E676\\]\\/90:hover {
  background-color: rgb(0 230 118 / 0.9);
}

.hover\\:bg-\\[\\#0A1628\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(10 22 40 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#243B55\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(36 59 85 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#243B55\\]\\/20:hover {
  background-color: rgb(36 59 85 / 0.2);
}

.hover\\:bg-\\[\\#243B55\\]\\/30:hover {
  background-color: rgb(36 59 85 / 0.3);
}

.hover\\:bg-\\[\\#243B55\\]\\/40:hover {
  background-color: rgb(36 59 85 / 0.4);
}

.hover\\:bg-\\[\\#243B55\\]\\/50:hover {
  background-color: rgb(36 59 85 / 0.5);
}

.hover\\:bg-\\[\\#2D4A6A\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(45 74 106 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#37474F\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(55 71 79 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#4FC3F7\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(79 195 247 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-900\\/30:hover {
  background-color: rgb(20 83 45 / 0.3);
}

.hover\\:bg-red-600\\/10:hover {
  background-color: rgb(220 38 38 / 0.1);
}

.hover\\:bg-red-600\\/20:hover {
  background-color: rgb(220 38 38 / 0.2);
}

.hover\\:bg-red-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-yellow-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-yellow-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(161 98 7 / var(--tw-bg-opacity, 1));
}

.hover\\:text-\\[\\#00D4FF\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(0 212 255 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#00D4FF\\]\\/80:hover {
  color: rgb(0 212 255 / 0.8);
}

.hover\\:text-\\[\\#00E676\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(0 230 118 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#B0BEC5\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(176 190 197 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#EF5350\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(239 83 80 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-300:hover {
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}

.hover\\:text-green-400:hover {
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-400:hover {
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:text-yellow-400:hover {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:opacity-80:hover {
  opacity: 0.8;
}

.focus\\:border-\\[\\#00D4FF\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(0 212 255 / var(--tw-border-opacity, 1));
}

.focus\\:border-\\[\\#00D4FF\\]\\/50:focus {
  border-color: rgb(0 212 255 / 0.5);
}

.focus\\:border-\\[\\#00E676\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(0 230 118 / var(--tw-border-opacity, 1));
}

.focus\\:border-transparent:focus {
  border-color: transparent;
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-\\[\\#00D4FF\\]:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(0 212 255 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}

.active\\:bg-\\[\\#243B55\\]:active {
  --tw-bg-opacity: 1;
  background-color: rgb(36 59 85 / var(--tw-bg-opacity, 1));
}

.active\\:bg-red-600\\/10:active {
  background-color: rgb(220 38 38 / 0.1);
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:bg-blue-800:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity, 1));
}

.disabled\\:opacity-40:disabled {
  opacity: 0.4;
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.disabled\\:hover\\:bg-transparent:hover:disabled {
  background-color: transparent;
}

.group:hover .group-hover\\:text-\\[\\#00D4FF\\] {
  --tw-text-opacity: 1;
  color: rgb(0 212 255 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}

@media (min-width: 400px) {
  .xs\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .xs\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .xs\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .xs\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}

@media (min-width: 640px) {
  .sm\\:col-span-1 {
    grid-column: span 1 / span 1;
  }
  .sm\\:col-span-2 {
    grid-column: span 2 / span 2;
  }
  .sm\\:col-span-3 {
    grid-column: span 3 / span 3;
  }
  .sm\\:ml-auto {
    margin-left: auto;
  }
  .sm\\:inline {
    display: inline;
  }
  .sm\\:flex {
    display: flex;
  }
  .sm\\:h-40 {
    height: 10rem;
  }
  .sm\\:w-32 {
    width: 8rem;
  }
  .sm\\:w-40 {
    width: 10rem;
  }
  .sm\\:max-w-xs {
    max-width: 20rem;
  }
  .sm\\:flex-none {
    flex: none;
  }
  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .sm\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .sm\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .sm\\:flex-row {
    flex-direction: row;
  }
  .sm\\:flex-col {
    flex-direction: column;
  }
  .sm\\:flex-wrap {
    flex-wrap: wrap;
  }
  .sm\\:items-start {
    align-items: flex-start;
  }
  .sm\\:items-end {
    align-items: flex-end;
  }
  .sm\\:items-center {
    align-items: center;
  }
  .sm\\:items-baseline {
    align-items: baseline;
  }
  .sm\\:justify-start {
    justify-content: flex-start;
  }
  .sm\\:justify-between {
    justify-content: space-between;
  }
  .sm\\:gap-1 {
    gap: 0.25rem;
  }
  .sm\\:gap-3 {
    gap: 0.75rem;
  }
  .sm\\:gap-3\\.5 {
    gap: 0.875rem;
  }
  .sm\\:gap-4 {
    gap: 1rem;
  }
  .sm\\:p-8 {
    padding: 2rem;
  }
  .sm\\:py-7 {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }
  .sm\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .sm\\:text-left {
    text-align: left;
  }
  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .sm\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

@media (min-width: 768px) {
  .md\\:order-none {
    order: 0;
  }
  .md\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }
  .md\\:mb-16 {
    margin-bottom: 4rem;
  }
  .md\\:mb-2 {
    margin-bottom: 0.5rem;
  }
  .md\\:mb-6 {
    margin-bottom: 1.5rem;
  }
  .md\\:mb-8 {
    margin-bottom: 2rem;
  }
  .md\\:ml-12 {
    margin-left: 3rem;
  }
  .md\\:ml-2 {
    margin-left: 0.5rem;
  }
  .md\\:ml-3 {
    margin-left: 0.75rem;
  }
  .md\\:mr-12 {
    margin-right: 3rem;
  }
  .md\\:block {
    display: block;
  }
  .md\\:inline {
    display: inline;
  }
  .md\\:flex {
    display: flex;
  }
  .md\\:grid {
    display: grid;
  }
  .md\\:hidden {
    display: none;
  }
  .md\\:h-16 {
    height: 4rem;
  }
  .md\\:h-32 {
    height: 8rem;
  }
  .md\\:h-8 {
    height: 2rem;
  }
  .md\\:w-16 {
    width: 4rem;
  }
  .md\\:w-28 {
    width: 7rem;
  }
  .md\\:w-32 {
    width: 8rem;
  }
  .md\\:w-40 {
    width: 10rem;
  }
  .md\\:w-56 {
    width: 14rem;
  }
  .md\\:w-8 {
    width: 2rem;
  }
  .md\\:w-auto {
    width: auto;
  }
  .md\\:max-w-\\[200px\\] {
    max-width: 200px;
  }
  .md\\:max-w-none {
    max-width: none;
  }
  .md\\:max-w-sm {
    max-width: 24rem;
  }
  .md\\:flex-1 {
    flex: 1 1;
  }
  .md\\:flex-none {
    flex: none;
  }
  .md\\:select-none {
    -webkit-user-select: none;
            user-select: none;
  }
  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .md\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
  .md\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
  .md\\:grid-cols-\\[1\\.1fr_1\\.5fr_1\\.7fr_0\\.9fr_auto\\] {
    grid-template-columns: 1.1fr 1.5fr 1.7fr 0.9fr auto;
  }
  .md\\:grid-cols-\\[1\\.3fr_1\\.5fr_1\\.2fr_1fr_1fr\\] {
    grid-template-columns: 1.3fr 1.5fr 1.2fr 1fr 1fr;
  }
  .md\\:flex-row {
    flex-direction: row;
  }
  .md\\:flex-wrap {
    flex-wrap: wrap;
  }
  .md\\:flex-nowrap {
    flex-wrap: nowrap;
  }
  .md\\:items-start {
    align-items: flex-start;
  }
  .md\\:items-end {
    align-items: flex-end;
  }
  .md\\:items-center {
    align-items: center;
  }
  .md\\:justify-between {
    justify-content: space-between;
  }
  .md\\:gap-0 {
    gap: 0px;
  }
  .md\\:gap-1\\.5 {
    gap: 0.375rem;
  }
  .md\\:gap-2 {
    gap: 0.5rem;
  }
  .md\\:gap-3 {
    gap: 0.75rem;
  }
  .md\\:gap-4 {
    gap: 1rem;
  }
  .md\\:gap-6 {
    gap: 1.5rem;
  }
  .md\\:gap-8 {
    gap: 2rem;
  }
  .md\\:truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .md\\:p-1\\.5 {
    padding: 0.375rem;
  }
  .md\\:p-5 {
    padding: 1.25rem;
  }
  .md\\:p-6 {
    padding: 1.5rem;
  }
  .md\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }
  .md\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .md\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .md\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .md\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
  .md\\:pl-0 {
    padding-left: 0px;
  }
  .md\\:pt-12 {
    padding-top: 3rem;
  }
  .md\\:text-right {
    text-align: right;
  }
  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .md\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .md\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .md\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }
  .md\\:text-\\[32px\\] {
    font-size: 32px;
  }
  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .md\\:text-\\[\\#B0BEC5\\] {
    --tw-text-opacity: 1;
    color: rgb(176 190 197 / var(--tw-text-opacity, 1));
  }
  .md\\:text-transparent {
    color: transparent;
  }
  .md\\:hover\\:scale-\\[1\\.02\\]:hover {
    --tw-scale-x: 1.02;
    --tw-scale-y: 1.02;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
}

@media (min-width: 1024px) {
  .lg\\:block {
    display: block;
  }
  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .lg\\:gap-1 {
    gap: 0.25rem;
  }
  .lg\\:border {
    border-width: 1px;
  }
  .lg\\:bg-\\[\\#1A2744\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(26 39 68 / var(--tw-bg-opacity, 1));
  }
  .lg\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .lg\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .lg\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}

@media (min-width: 1280px) {
  .xl\\:block {
    display: block;
  }
}

@media (min-width: 1536px) {
  .\\32xl\\:gap-6 {
    gap: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAAd,kEAAc;AAAd;;;CAAc;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;EAAA,gBAAc;AAAA;AAAd;;;;;;;;CAAc;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,iCAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,mBAAc;AAAA;AAAd;;;;;CAAc;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,cAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;AAAd;EAAA,eAAc;AAAA;AAAd;EAAA,WAAc;AAAA;AAAd;;;;CAAc;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,oBAAc;AAAA;AAAd;;;CAAc;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,aAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,YAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,wBAAc;AAAA;AAAd;;;CAAc;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,kBAAc;AAAA;AAAd;;CAAc;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;AAAd;EAAA,UAAc;AAAA;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,gBAAc;AAAA;AAAd;;;CAAc;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;AAAA;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;AAAd;;;;CAAc;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;AAAd;;CAAc;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB,kCAAkC;;AAGlC,qBAAqB;AACrB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,kDAAkD;EAClD,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;;EAEtB,0CAA0C;EAC1C,sBAAsB;EACtB,uBAAuB;EACvB,qCAAqC;;EAErC,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;;EAErB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;;EAEtB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;;EAEnB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;;EAEnB,YAAY;EACZ,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,+EAA+E;EAC/E,mCAAmC;EACnC,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,mCAAmC;AACrC;;AAEA,eAAe;AACf;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,6CAA6C;EAC7C,UAAU;AACZ;;AAEA,aAAa,qBAAqB,EAAE;AACpC,aAAa,qBAAqB,EAAE;AACpC,aAAa,qBAAqB,EAAE;AACpC,aAAa,qBAAqB,EAAE;AACpC,aAAa,qBAAqB,EAAE;AACpC,aAAa,qBAAqB,EAAE;;AAEpC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,sBAAsB;AACtB;EACE,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,iDAAiD;AACnD;;AAEA,eAAe;AACf;EACE,2CAA2C;EAC3C,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,oCAAoC;EACpC,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;;+EAI+E;;AAE/E;EACE,oEAAoE;EACpE,yCAAyC;EACzC,+CAA+C;EAC/C,2CAA2C;EAC3C,6CAA6C;;EAE7C,8CAA8C;EAC9C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;EAEpD,sBAAsB;AACxB;;AAEA;EACE,iFAAiF;EACjF,wCAAwC;EACxC,wEAAwE;EACxE,2BAA2B;AAC7B;;AAEA,4DAA4D;AAC5D;EACE,gBAAgB;EAChB,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA,mEAAmE;AACnE;EACE,yBAAyB;EACzB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE;4EAC0E;EAC1E;;;IAGE,0BAA0B;EAC5B;;EAEA,yEAAyE;EACzE;;;;IAIE,gBAAgB;EAClB;;EAEA,0CAA0C;EAC1C;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA,kEAAkE;EAClE;IACE,iCAAiC;IACjC,gBAAgB;EAClB;;EAEA;;IAEE,yBAAyB;IACzB,eAAe;EACjB;AACF;;AAEA;yEACyE;AACzE;EACE;;IAEE,eAAe;IACf,2CAA2C;EAC7C;;EAEA;;;IAGE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,iCAAiC;IACjC,gBAAgB;EAClB;AACF;;AAEA;;+EAE+E;;AAE/E;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,4BAA4B;EAC5B,wCAAwC;EACxC,0CAA0C;EAC1C,kDAAkD;EAClD,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,kCAAkC;EAClC,8BAA8B;EAC9B,gCAAgC;EAChC,wCAAwC;EACxC,0CAA0C;EAC1C,kDAAkD;EAClD,yCAAyC;AAC3C;;AAEA;EACE,SAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;EACE;IACE,iEAAiE;EACnE;AACF;;AAEA;;+EAE+E;;AAE/E;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,0EAA0E;EAC1E;IACE,gCAAgC;IAChC,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;IAC3B,uCAAuC;IACvC,wDAAwD;IACxD,8CAA8C;EAChD;;EAEA,wEAAwE;EACxE;IACE,WAAW;IACX,cAAc;IACd,WAAW;IACX,WAAW;IACX,oBAAoB;IACpB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;EAChB;AACF;;AAEA;;;+EAG+E;;AAE/E;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,qFAAqF;AACrF;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA,yCAAyC;AACzC;EACE,gCAAgC;EAChC,qCAAqC;EACrC,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,iFAAiF;AACjF;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,gCAAgC;EAChC,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA,uCAAuC;AACvC;EACE;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;AACF;;AAEA;;;;;;;+EAO+E;;AAE/E;EACE,gBAAgB;EAChB,iCAAiC;EACjC,WAAW;EACX,uBAAuB;EACvB,oBAAoB;EACpB,wCAAwC;EACxC,0CAA0C;EAC1C,kDAAkD;EAClD,4CAA4C;AAC9C;;AAEA;EACE;IACE,MAAM;IACN,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,qEAAqE;AACrE;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,kFAAkF;AACpF;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,uBAAuB;EACvB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA,0EAA0E;AAC1E;EACE;IACE,uBAAuB;IACvB,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA,wEAAwE;AACxE;EACE,4DAA4D;AAC9D;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AA1oBA;EAAA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA,sBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA,kBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA,kBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA,kBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA,kBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA,kBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA,kBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA,kBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA,kBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA,kBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA,kBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA,kBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA,oBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA,oBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA,oBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA,oBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA,oBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA,oBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA,oBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA,oBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA,oBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA,sBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA,sBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA,8BA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA,2GA2oBA;EA3oBA,yGA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA,oBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA,oBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA,kBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA,kBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA,oBA2oBA;EA3oBA;AA2oBA;;AA3oBA;EAAA;AA2oBA;;AA3oBA;EAAA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;AAAA;;AA3oBA;EAAA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA,oBA2oBA;IA3oBA;EA2oBA;EA3oBA;IAAA,iBA2oBA;IA3oBA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA,iBA2oBA;IA3oBA;EA2oBA;EA3oBA;IAAA,mBA2oBA;IA3oBA;EA2oBA;EA3oBA;IAAA,kBA2oBA;IA3oBA;EA2oBA;EA3oBA;IAAA,eA2oBA;IA3oBA;EA2oBA;EA3oBA;IAAA,mBA2oBA;IA3oBA;EA2oBA;EA3oBA;IAAA,mBA2oBA;IA3oBA;EA2oBA;AAAA;;AA3oBA;EAAA;IAAA;EA2oBA;EA3oBA;IAAA,gBA2oBA;IA3oBA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA,yBA2oBA;YA3oBA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA,gBA2oBA;IA3oBA,uBA2oBA;IA3oBA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA,iBA2oBA;IA3oBA;EA2oBA;EA3oBA;IAAA,qBA2oBA;IA3oBA;EA2oBA;EA3oBA;IAAA,oBA2oBA;IA3oBA;EA2oBA;EA3oBA;IAAA,kBA2oBA;IA3oBA;EA2oBA;EA3oBA;IAAA,iBA2oBA;IA3oBA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA,iBA2oBA;IA3oBA;EA2oBA;EA3oBA;IAAA,mBA2oBA;IA3oBA;EA2oBA;EA3oBA;IAAA,kBA2oBA;IA3oBA;EA2oBA;EA3oBA;IAAA,eA2oBA;IA3oBA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA,eA2oBA;IA3oBA;EA2oBA;EA3oBA;IAAA,mBA2oBA;IA3oBA;EA2oBA;EA3oBA;IAAA,kBA2oBA;IA3oBA;EA2oBA;EA3oBA;IAAA,oBA2oBA;IA3oBA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA,kBA2oBA;IA3oBA,kBA2oBA;IA3oBA;EA2oBA;AAAA;;AA3oBA;EAAA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA;EA2oBA;EA3oBA;IAAA,kBA2oBA;IA3oBA;EA2oBA;EA3oBA;IAAA,qBA2oBA;IA3oBA;EA2oBA;EA3oBA;IAAA,oBA2oBA;IA3oBA;EA2oBA;EA3oBA;IAAA,mBA2oBA;IA3oBA;EA2oBA;AAAA;;AA3oBA;EAAA;IAAA;EA2oBA;AAAA;;AA3oBA;EAAA;IAAA;EA2oBA;AAAA","sourcesContent":["/* Tailwind CSS Directives */\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* AiDA Advisory - Global Styles */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=Rajdhani:wght@600;700&display=swap');\n\n/* CSS Reset & Base */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n:root {\n  /* Backgrounds - Deep navy/space theme from logo */\n  --bg-primary: #0A0E27;\n  --bg-card: #1A2744;\n  --bg-elevated: #243B55;\n  \n  /* Accent Colors - Bright cyan from logo */\n  --accent-cyan: #00D4FF;\n  --accent-light: #4FC3F7;\n  --accent-glow: rgba(0, 212, 255, 0.3);\n  \n  /* Score Colors */\n  --score-green: #00E676;\n  --score-elite: #00E676;\n  --score-strong: #00C853;\n  --score-good: #FFD600;\n  --score-marginal: #FFB300;\n  --score-poor: #EF5350;\n  \n  /* Dimension Colors */\n  --scheme-fit: #00D4FF;\n  --skill-fit: #FFB300;\n  --physical-fit: #00E676;\n  --mental-fit: #7E57C2;\n  --context-fit: #546E7A;\n  \n  /* Status Colors */\n  --warn-amber: #FFB300;\n  --risk-red: #EF5350;\n  \n  /* Text Colors */\n  --text-primary: #FFFFFF;\n  --text-muted: #B0BEC5;\n  --text-dim: #546E7A;\n  \n  /* Borders */\n  --border: #546E7A;\n  --border-light: rgba(84, 110, 122, 0.3);\n}\n\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  background-color: var(--bg-primary);\n  color: var(--text-primary);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  min-height: 100vh;\n}\n\n/* Number font for scores */\n.font-rajdhani {\n  font-family: 'Rajdhani', sans-serif;\n}\n\n/* Animations */\n@keyframes pulse-glow {\n  0%, 100% {\n    box-shadow: 0 0 20px rgba(0, 230, 118, 0.4);\n  }\n  50% {\n    box-shadow: 0 0 40px rgba(0, 230, 118, 0.6);\n  }\n}\n\n@keyframes cyan-glow {\n  0%, 100% {\n    box-shadow: 0 0 20px rgba(0, 212, 255, 0.4);\n  }\n  50% {\n    box-shadow: 0 0 40px rgba(0, 212, 255, 0.6);\n  }\n}\n\n.pulse-glow {\n  animation: pulse-glow 2s ease-in-out;\n}\n\n.cyan-glow {\n  animation: cyan-glow 2s ease-in-out infinite;\n}\n\n@keyframes slideInLeft {\n  from {\n    transform: translateX(-100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.slide-in-left {\n  animation: slideInLeft 0.6s ease-out forwards;\n  opacity: 0;\n}\n\n.delay-100 { animation-delay: 0.1s; }\n.delay-200 { animation-delay: 0.2s; }\n.delay-300 { animation-delay: 0.3s; }\n.delay-400 { animation-delay: 0.4s; }\n.delay-500 { animation-delay: 0.5s; }\n.delay-600 { animation-delay: 0.6s; }\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.fade-in {\n  animation: fadeIn 0.5s ease-out forwards;\n}\n\n/* Panel base styles */\n.panel-card {\n  background-color: var(--bg-card);\n  border: 1px solid var(--border-light);\n  border-radius: 12px;\n  padding: 1.25rem;\n  transition: all 0.3s ease;\n}\n\n.panel-card:hover {\n  border-color: var(--accent-light);\n  box-shadow: inset 0 1px 0 rgba(79, 195, 247, 0.1);\n}\n\n/* Tab styles */\n.tab-active {\n  border-bottom: 2px solid var(--accent-cyan);\n  color: var(--text-primary);\n  font-weight: 600;\n  padding-bottom: 0.5rem;\n}\n\n.tab-inactive {\n  color: var(--text-muted);\n  padding-bottom: 0.5rem;\n  cursor: pointer;\n  transition: color 0.2s;\n}\n\n.tab-inactive:hover {\n  color: var(--text-primary);\n}\n\n/* Button styles */\n.btn-primary {\n  background-color: var(--accent-cyan);\n  color: var(--bg-primary);\n  font-weight: 600;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 0 20px rgba(0, 212, 255, 0.3);\n  font-size: 14px;\n}\n\n.btn-primary:hover {\n  background-color: var(--accent-light);\n  box-shadow: 0 0 30px rgba(0, 212, 255, 0.5);\n  transform: translateY(-2px);\n}\n\n.btn-secondary {\n  background-color: transparent;\n  color: var(--text-primary);\n  font-weight: 600;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  border: 2px solid var(--border);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 14px;\n}\n\n.btn-secondary:hover {\n  border-color: var(--accent-light);\n  color: var(--accent-light);\n}\n\n/* Link styles */\na {\n  color: var(--accent-cyan);\n  text-decoration: none;\n  transition: color 0.2s;\n}\n\na:hover {\n  color: var(--accent-light);\n}\n\n/* Utility classes */\n.text-cyan {\n  color: var(--accent-cyan);\n}\n\n.text-green {\n  color: var(--score-green);\n}\n\n.text-amber {\n  color: var(--warn-amber);\n}\n\n.text-muted {\n  color: var(--text-muted);\n}\n\n.bg-card {\n  background-color: var(--bg-card);\n}\n\n.border-cyan {\n  border-color: var(--accent-cyan);\n}\n\n/* ==========================================================================\n   MOBILE / NATIVE-APP LAYER\n   Goal: on a phone this should read as an installed app, not a shrunken\n   desktop site. Desktop (>= 768px) behavior is intentionally left unchanged.\n   ========================================================================== */\n\n:root {\n  /* Safe areas (notch / home indicator). Fall back to 0 off-device. */\n  --safe-top: env(safe-area-inset-top, 0px);\n  --safe-bottom: env(safe-area-inset-bottom, 0px);\n  --safe-left: env(safe-area-inset-left, 0px);\n  --safe-right: env(safe-area-inset-right, 0px);\n\n  /* Chrome heights, used to offset fixed bars */\n  --appbar-h: 56px;\n  --tabbar-h: 56px;\n}\n\nhtml {\n  /* Stop iOS inflating text when the device rotates */\n  -webkit-text-size-adjust: 100%;\n  text-size-adjust: 100%;\n}\n\nbody {\n  /* Kill the gray flash box on tap - the single biggest \"this is a webpage\" tell */\n  -webkit-tap-highlight-color: transparent;\n  /* No rubber-band chaining to the document / no pull-to-refresh bounce */\n  overscroll-behavior-y: none;\n}\n\n/* Native-feeling momentum scrolling inside scroll regions */\n.scroll-y {\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n}\n\n/* App chrome should not be text-selectable the way a document is */\n.app-chrome {\n  -webkit-user-select: none;\n  user-select: none;\n  -webkit-touch-callout: none;\n}\n\n@media (max-width: 767px) {\n  /* iOS zooms the viewport when a focused input is under 16px. This is the\n     other classic \"not an app\" tell, so force 16px on every text control. */\n  input,\n  select,\n  textarea {\n    font-size: 16px !important;\n  }\n\n  /* Touch targets: 44px is the Apple HIG minimum, 48dp the Material one. */\n  button,\n  [role=\"button\"],\n  a.tap,\n  select {\n    min-height: 44px;\n  }\n\n  /* Tighter gutters than the desktop px-6 */\n  .panel-card {\n    padding: 1rem;\n    border-radius: 14px;\n  }\n\n  /* Hover styling is meaningless on touch and leaves stuck states */\n  .panel-card:hover {\n    border-color: var(--border-light);\n    box-shadow: none;\n  }\n\n  .btn-primary,\n  .btn-secondary {\n    padding: 0.875rem 1.25rem;\n    font-size: 15px;\n  }\n}\n\n/* On any touch device, replace hover affordances with press feedback.\n   The desktop translateY(-2px) hover reads as a glitch under a finger. */\n@media (hover: none) {\n  .btn-primary:hover,\n  .btn-secondary:hover {\n    transform: none;\n    box-shadow: 0 0 20px rgba(0, 212, 255, 0.3);\n  }\n\n  .btn-primary:active,\n  .btn-secondary:active,\n  .tap:active {\n    transform: scale(0.97);\n    opacity: 0.85;\n  }\n\n  .panel-card:hover {\n    border-color: var(--border-light);\n    box-shadow: none;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   App shell: fixed top app bar + fixed bottom tab bar (mobile only)\n   -------------------------------------------------------------------------- */\n\n.app-bar {\n  position: sticky;\n  top: 0;\n  z-index: 40;\n  padding-top: var(--safe-top);\n  background-color: rgba(26, 39, 68, 0.92);\n  backdrop-filter: saturate(180%) blur(12px);\n  -webkit-backdrop-filter: saturate(180%) blur(12px);\n  border-bottom: 1px solid var(--border-light);\n}\n\n.tab-bar {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 50;\n  display: flex;\n  align-items: stretch;\n  padding-bottom: var(--safe-bottom);\n  padding-left: var(--safe-left);\n  padding-right: var(--safe-right);\n  background-color: rgba(26, 39, 68, 0.94);\n  backdrop-filter: saturate(180%) blur(16px);\n  -webkit-backdrop-filter: saturate(180%) blur(16px);\n  border-top: 1px solid var(--border-light);\n}\n\n.tab-bar-item {\n  flex: 1 1 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 3px;\n  height: var(--tabbar-h);\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  color: var(--text-dim);\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: color 0.15s ease;\n  min-width: 0;\n}\n\n.tab-bar-item.is-active {\n  color: var(--accent-cyan);\n}\n\n.tab-bar-item:active {\n  opacity: 0.6;\n}\n\n.tab-bar-item span {\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Content must clear the fixed tab bar */\n@media (max-width: 767px) {\n  .has-tab-bar {\n    padding-bottom: calc(var(--tabbar-h) + var(--safe-bottom) + 12px);\n  }\n}\n\n/* --------------------------------------------------------------------------\n   Sheets: modals become bottom sheets on mobile, stay dialogs on desktop\n   -------------------------------------------------------------------------- */\n\n@keyframes sheet-up {\n  from {\n    transform: translateY(100%);\n  }\n  to {\n    transform: translateY(0);\n  }\n}\n\n@keyframes overlay-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.sheet-overlay {\n  animation: overlay-in 0.2s ease-out;\n}\n\n@media (max-width: 767px) {\n  /* Pin the overlay to the viewport and let the sheet own the bottom edge */\n  .sheet-overlay {\n    align-items: flex-end !important;\n    padding: 0 !important;\n  }\n\n  .sheet {\n    width: 100% !important;\n    max-width: 100% !important;\n    max-height: 92vh !important;\n    border-radius: 18px 18px 0 0 !important;\n    animation: sheet-up 0.28s cubic-bezier(0.32, 0.72, 0, 1);\n    padding-bottom: calc(var(--safe-bottom) + 8px);\n  }\n\n  /* The little grab handle that signals \"drag/dismiss\" on native sheets */\n  .sheet::before {\n    content: \"\";\n    display: block;\n    width: 36px;\n    height: 4px;\n    border-radius: 999px;\n    background: var(--border);\n    margin: 10px auto 4px;\n    flex-shrink: 0;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   Table -> card list. Wrap a <table> in .table-wrap and it scrolls on\n   desktop; screens that provide a .card-list fallback hide the table instead.\n   -------------------------------------------------------------------------- */\n\n.table-wrap {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.mobile-only {\n  display: none;\n}\n\n@media (max-width: 767px) {\n  .mobile-only {\n    display: block;\n  }\n\n  .desktop-only {\n    display: none !important;\n  }\n}\n\n/* For tables too wide for a tablet: the table from 1024px up, the card list below. */\n.narrow-only {\n  display: none;\n}\n\n@media (max-width: 1023px) {\n  .narrow-only {\n    display: block;\n  }\n\n  .wide-only {\n    display: none !important;\n  }\n}\n\n/* A tappable row/card in a mobile list */\n.list-card {\n  background-color: var(--bg-card);\n  border: 1px solid var(--border-light);\n  border-radius: 14px;\n  padding: 0.875rem 1rem;\n  display: block;\n  width: 100%;\n  text-align: left;\n  transition: background-color 0.15s ease;\n}\n\n.list-card:active {\n  background-color: var(--bg-elevated);\n}\n\n/* A row of chips/filters. It wraps onto more lines; it never scrolls sideways. */\n.chip-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  padding-bottom: 2px;\n}\n\n.chip-row::-webkit-scrollbar {\n  display: none;\n}\n\n.chip {\n  flex: 0 0 auto;\n  padding: 0.5rem 0.875rem;\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n  border: 1px solid var(--border-light);\n  background-color: var(--bg-card);\n  color: var(--text-muted);\n  cursor: pointer;\n}\n\n.chip.is-active {\n  background-color: var(--accent-cyan);\n  border-color: var(--accent-cyan);\n  color: var(--bg-primary);\n}\n\n/* Respect reduced-motion preferences */\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n\n/* --------------------------------------------------------------------------\n   Public profile section tabs\n\n   Pinned under the app bar so they stay reachable while reading, with the\n   active section tracked as you scroll. Six labels cannot fit across a phone,\n   so the strip scrolls horizontally -- the same pattern as Material's\n   scrollable tabs -- and a fade on the trailing edge signals there is more.\n   -------------------------------------------------------------------------- */\n\n.section-nav {\n  position: sticky;\n  top: calc(var(--safe-top) + 56px);\n  z-index: 30;\n  margin: 0 -1rem 1.25rem;\n  padding: 0.5rem 1rem;\n  background-color: rgba(10, 14, 39, 0.94);\n  backdrop-filter: saturate(180%) blur(12px);\n  -webkit-backdrop-filter: saturate(180%) blur(12px);\n  border-bottom: 1px solid var(--border-light);\n}\n\n@media (min-width: 768px) {\n  .section-nav {\n    top: 0;\n    margin-left: 0;\n    margin-right: 0;\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n\n/* Trailing fade: the affordance that says \"this strip keeps going\" */\n.section-nav::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 28px;\n  pointer-events: none;\n  background: linear-gradient(to right, rgba(10, 14, 39, 0), rgba(10, 14, 39, 0.94));\n}\n\n.section-nav .chip-row {\n  gap: 0.4rem;\n  scroll-behavior: smooth;\n}\n\n.section-nav .chip {\n  padding: 0.45rem 0.7rem;\n  font-size: 12px;\n  letter-spacing: -0.01em;\n  text-decoration: none;\n  scroll-margin-inline: 1rem;\n}\n\n/* On a narrow phone, let the strip use the full width before it scrolls */\n@media (max-width: 400px) {\n  .section-nav .chip {\n    padding: 0.45rem 0.6rem;\n    font-size: 11.5px;\n  }\n  .section-nav .chip-row {\n    gap: 0.3rem;\n  }\n}\n\n.section-nav .chip.is-active {\n  background-color: var(--accent-cyan);\n  border-color: var(--accent-cyan);\n  color: var(--bg-primary);\n}\n\n/* Anchor targets must clear both the app bar and the pinned tab strip */\n.section-anchor {\n  scroll-margin-top: calc(var(--safe-top) + 56px + 52px + 8px);\n}\n\n@media (min-width: 768px) {\n  .section-anchor {\n    scroll-margin-top: 72px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
